export const SET_SUGGESTION_GROUPS_MUTATION = 'setSuggestionGroupsMutation';
export const ADD_SUGGESTION_GROUP_MUTATION = 'addSuggestionGroupMutation';
export const EDIT_SUGGESTION_GROUP_MUTATION = 'editSuggestionGroupMutation';
export const DELETE_SUGGESTION_GROUP_MUTATION = 'deleteSuggestionGroupMutation';
export const GET_SUGGESTION_GROUPS = 'getSuggestionGroups';
